document.addEventListener('alpine:init', () => {
  Alpine.data('Theme_ProductMediaVideo', () => ({
    player: null,
    productMediaWrapper: null,
    enabled: true, // Zawsze aktywne
    playing: false,

    init() {
      this.initPlayer();
      this.play();

      
      document.body.addEventListener('pauseAllMedia', (e) => {
        if (e.detail !== null && e.detail.id === this.$root.id) {
          return;
        }
        this.pause();
      });

      this.$watch('playing', (value) => {
        if (value === true) {
          this.dispatchPauseAllMediaEvent();
        }
      });

      this.productMediaWrapper = this.$root.closest('[data-product-single-media-wrapper]');

      if (this.productMediaWrapper) {
        this.setUpProductMediaListeners();
      }
    },

    initPlayer() {
      if (!this.player) {
        this.player = this.$root.querySelector('[\\@play][\\@pause]');
      }
    },

    setUpProductMediaListeners() {
      this.productMediaWrapper.addEventListener('mediaHidden', () => {
        this.pause();
      });

      this.productMediaWrapper.addEventListener('mediaVisible', () => {
        this.play();
      });
    },

    dispatchPauseAllMediaEvent() {
      document.body.dispatchEvent(
        new CustomEvent('pauseAllMedia', {
          detail: {
            id: this.$root.id,
          },
        })
      );
    },

    play() {
      if (!this.player) {
        this.initPlayer();
      }
      if (this.player) {
        this.player.dispatchEvent(new CustomEvent('play'));
      }
    },

    pause() {
      if (this.player) {
        this.player.dispatchEvent(new CustomEvent('pause'));
      }
    }
  }));
});
